
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import ptTranslations from './locales/pt.json';

// Email template translations for Portuguese
// These will be merged with the existing translations using proper namespacing
const ptEmailTemplateTranslations = {
  email_templates: {
    // Default template names
    default_initial_email_name: "E-mail Inicial Padrão",
    default_first_reminder_name: "Primeiro Lembrete Padrão",
    default_second_reminder_name: "Segundo Lembrete Padrão",
    default_final_reminder_name: "Lembrete Final Padrão",
    
    // Template content translations
    default_greeting: "Prezado(a)",
    default_initial_message: "Segue em anexo a fatura",
    default_for_amount: "no valor de",
    default_payment_due: "O pagamento deve ser feito até",
    default_regards: "Atenciosamente",
    
    // Reminder messages
    default_reminder_message: "Este é um lembrete amigável sobre a fatura",
    default_which_due: "que venceu em",
    default_prompt_payment: "Agradecemos o seu pagamento o mais breve possível.",
    
    // Second reminder
    default_second_reminder: "Ainda não recebemos o pagamento da fatura",
    default_second_payment_request: "Por favor, providencie o pagamento o mais rápido possível.",
    
    // Final reminder
    default_final_reminder: "Este é o nosso lembrete final sobre o pagamento da fatura",
    default_final_payment_notice: "Por favor, observe que se o pagamento não for recebido dentro de 7 dias, poderemos precisar tomar medidas adicionais."
  }
};

// Email template translations for French
const frEmailTemplateTranslations = {
  email_templates: {
    // Default template names
    default_initial_email_name: "Email Initial Par Défaut",
    default_first_reminder_name: "Premier Rappel Par Défaut",
    default_second_reminder_name: "Deuxième Rappel Par Défaut",
    default_final_reminder_name: "Rappel Final Par Défaut",
    
    // Template content translations
    default_greeting: "Cher/Chère",
    default_initial_message: "Veuillez trouver ci-joint la facture",
    default_for_amount: "pour un montant de",
    default_payment_due: "Le paiement est dû avant le",
    default_regards: "Cordialement",
    
    // Reminder messages
    default_reminder_message: "Ceci est un rappel amical concernant la facture",
    default_which_due: "qui était due le",
    default_prompt_payment: "Nous vous serions reconnaissants de procéder au paiement rapidement.",
    
    // Second reminder
    default_second_reminder: "Nous n'avons pas encore reçu le paiement de la facture",
    default_second_payment_request: "Veuillez organiser le paiement dès que possible.",
    
    // Final reminder
    default_final_reminder: "Ceci est notre dernier rappel concernant le paiement de la facture",
    default_final_payment_notice: "Veuillez noter que si le paiement n'est pas reçu dans les 7 jours, nous devrons peut-être prendre d'autres mesures."
  }
};

// Email template translations for English
const enEmailTemplateTranslations = {
  email_templates: {
    // Default template names
    default_initial_email_name: "Default Initial Email",
    default_first_reminder_name: "Default First Reminder",
    default_second_reminder_name: "Default Second Reminder",
    default_final_reminder_name: "Default Final Reminder",
    
    // Template content translations
    default_greeting: "Dear",
    default_initial_message: "Please find attached the invoice",
    default_for_amount: "for",
    default_payment_due: "Payment is due by",
    default_regards: "Best regards",
    
    // Reminder messages
    default_reminder_message: "This is a friendly reminder about invoice",
    default_which_due: "which was due on",
    default_prompt_payment: "We would appreciate your prompt payment.",
    
    // Second reminder
    default_second_reminder: "We have not yet received payment for invoice",
    default_second_payment_request: "Please arrange for payment as soon as possible.",
    
    // Final reminder
    default_final_reminder: "This is our final reminder regarding payment for invoice",
    default_final_payment_notice: "Please note that if payment is not received within 7 days, we may need to take further action."
  }
};

// Helper function for deep merging objects
function deepMerge(target: any, source: any) {
  const output = { ...target };
  
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (
        typeof source[key] === 'object' && 
        source[key] !== null && 
        !Array.isArray(source[key])
      ) {
        if (key in target && typeof target[key] === 'object' && !Array.isArray(target[key])) {
          output[key] = deepMerge(target[key], source[key]);
        } else {
          output[key] = { ...source[key] };
        }
      } else {
        output[key] = source[key];
      }
    }
  }
  
  return output;
}

// Merge the email template translations with the existing translations using deep merge
const mergedEnTranslations = deepMerge(enTranslations, enEmailTemplateTranslations);
const mergedFrTranslations = deepMerge(frTranslations, frEmailTemplateTranslations);
const mergedPtTranslations = deepMerge(ptTranslations, ptEmailTemplateTranslations);


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: mergedEnTranslations
      },
      fr: {
        translation: mergedFrTranslations
      },
      pt: {
        translation: mergedPtTranslations
      }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    debug: true // Enable debug mode to see more logging
  });

export default i18n;
